/* ABC: «товар удалён — вернуть». Владелец: после удаления из корзины
   (DELETE или «−» до нуля) показываем плашку с названием и кнопкой UNDO,
   5 секунд. Работает и в мини-корзине, и на странице /cart.
   Как устроено: держим свежий снимок корзины (/cart.js), при событии
   удаления строки берём из снимка вариант и количество; UNDO кладёт их
   обратно и сообщает теме тем же событием, что и сама тема — корзина,
   счётчик и итог перерисовываются. */
import { CartLinesUpdateEvent } from '@shopify/events';

const UNDO_MS = 5000;
let snapshot = [];
let toast = null;
let timer = 0;
/* удалённые за время показа плашки — UNDO вернёт их все */
let pending = [];

async function refreshSnapshot() {
  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    snapshot = cart.items || [];
  } catch (e) {}
}

function sectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

function hideToast() {
  clearTimeout(timer);
  if (!toast) return;
  const t = toast;
  toast = null;
  pending = [];
  /* обратно: «REMOVED» уезжает вниз, CHECKOUT возвращается сверху */
  t.classList.remove('is-swapped');
  if (keeper) { keeper.disconnect(); keeper = null; }
  setTimeout(() => t.remove(), 260);
}

let host = null;
let keeper = null;

/* кнопка, на которую ложится плашка: CHECKOUT, а если корзина опустела —
   CONTINUE SHOPPING пустой корзины (решение владельца, 25.09) */
function target(drawer) {
  return drawer
    ? (drawer.querySelector('.cart__checkout-button') || drawer.querySelector('.cart-items__empty-button'))
    : (document.querySelector('.abc-sticky-checkout.is-visible .abc-sticky-checkout__btn') || document.querySelector('.cart-page .cart__checkout-button') || document.querySelector('.cart-items__empty-button'));
}

function place(el) {
  const drawer = host;
  const btn = target(drawer);
  const r = btn ? btn.getBoundingClientRect() : null;
  /* подпись, которая уезжает вверх, — текст той кнопки, что под плашкой */
  const ghost = el.querySelector('.abc-undo__ghost');
  el.dataset.on = btn && btn.classList.contains('cart-items__empty-button') ? 'empty' : 'checkout';
  const gt = btn ? btn.textContent.trim() : '';
  /* сравниваем: запись текста — тоже изменение, наблюдатель keeper зациклился бы */
  if (ghost && gt && ghost.textContent !== gt) ghost.textContent = gt;
  if (drawer && r && r.width) {
    const d = drawer.getBoundingClientRect();
    el.classList.add('abc-undo--anchored');
    el.style.left = r.left - d.left - drawer.clientLeft + 'px';
    el.style.top = r.top - d.top - drawer.clientTop + 'px';
    el.style.width = r.width + 'px';
    el.style.height = r.height + 'px';
    el.style.bottom = 'auto';
  } else if (drawer) {
    /* корзина опустела — кнопки нет, плашка внизу шторки */
    el.classList.add('abc-undo--anchored');
    el.style.left = '20px';
    el.style.width = 'calc(100% - 40px)';
    el.style.top = 'auto';
    el.style.bottom = '20px';
  } else if (r && r.width) {
    el.style.left = r.left + 'px';
    el.style.width = r.width + 'px';
    /* на /cart поверх плавающей кнопки CHECKOUT, если она видна */
    el.style.height = r.height + 'px';
    el.style.bottom = 'auto';
    if (btn.classList.contains('abc-sticky-checkout__btn')) {
      el.style.position = 'fixed';
      el.style.top = r.top + 'px';
    } else {
      /* настоящая кнопка на странице — плашка ложится на неё и едет вместе
         со страницей (позицию обновляем при прокрутке, см. ниже) */
      el.style.position = 'fixed';
      el.style.top = r.top + 'px';
    }
  }
}

function mount(el, drawer) {
  host = drawer || null;
  (drawer || document.body).appendChild(el);
  place(el);
  /* тема перерисовывает шторку и выкидывает чужие элементы — возвращаем */
  if (keeper) keeper.disconnect();
  if (drawer) {
    keeper = new MutationObserver(() => {
      if (toast !== el || !drawer.open) return;
      if (!el.isConnected) drawer.appendChild(el);
      /* после удаления последней вещи на месте CHECKOUT появляется CONTINUE SHOPPING */
      place(el);
    });
    keeper.observe(drawer, { childList: true, subtree: true });
  }
}

addEventListener('resize', () => { if (toast) place(toast); });
/* на /cart плашка лежит на кнопке — едет вместе с прокруткой (любого блока) */
document.addEventListener('scroll', () => { if (toast && !host) place(toast); }, { passive: true, capture: true });

function label() {
  if (pending.length === 1) return (pending[0].product_title || pending[0].title || '').toUpperCase() + ' REMOVED';
  return pending.length + ' ITEMS REMOVED';
}

function showToast(item) {
  /* плашка уже висит — дописываем товар, текст «N ITEMS REMOVED», отсчёт заново */
  /* проверяем сам объект плашки, а не «в документе ли она»: перерисовка
     корзины на миг выкидывает её (keeper возвращает), и второе удаление
     раньше начинало новую плашку — терялись предыдущие товары */
  if (toast) {
    pending.push(item);
    if (!toast.isConnected && host) { host.appendChild(toast); place(toast); }
    toast.querySelector('.abc-undo__text').textContent = label();
    const bar = toast.querySelector('.abc-undo__bar');
    if (bar) { bar.style.animation = 'none'; bar.getBoundingClientRect(); bar.style.animation = ''; }
    clearTimeout(timer);
    timer = setTimeout(hideToast, UNDO_MS);
    return;
  }
  hideToast();
  pending = [item];
  const title = (item.product_title || item.title || '').toUpperCase();
  const el = document.createElement('div');
  el.className = 'abc-undo abc-undo--instant';
  el.setAttribute('role', 'status');
  /* текст кнопки CHECKOUT уезжает вверх, снизу въезжает «… REMOVED · UNDO» —
     та же механика, что у «ADDED TO CART» на кнопке товара */
  el.innerHTML =
    '<span class="abc-undo__ghost"></span>' +
    '<span class="abc-undo__content"><span class="abc-undo__text"></span>' +
    '<button type="button" class="abc-undo__btn">UNDO</button></span>' +
    '<span class="abc-undo__bar"></span>';
  el.querySelector('.abc-undo__text').textContent = label();
  el.querySelector('.abc-undo__btn').addEventListener('click', () => restore(pending.slice()));
  /* нажатие по плашке никуда дальше не уходит (под ней кнопка чекаута) */
  el.addEventListener('click', (e) => { e.stopPropagation(); if (!e.target.closest('.abc-undo__btn')) e.preventDefault(); });
  el.style.setProperty('--abc-undo-ms', UNDO_MS + 'ms');

  /* Где показывать (решение владельца, 22.09):
     - мини-корзина открыта — плашка ложится ровно на кнопку CHECKOUT (та же
       ширина и высота). Кладём ВНУТРЬ шторки: всё, что снаружи открытой
       модальной шторки, браузер делает «неживым», и нажатие по плашке
       проваливалось на кнопку чекаута под ней;
     - страница /cart — внизу экрана, по ширине кнопки чекаута. */
  const drawer = document.querySelector('#cart-drawer dialog[open]');
  mount(el, drawer);
  toast = el;
  el.getBoundingClientRect();
  el.classList.add('is-visible');
  setTimeout(() => el.classList.add('is-swapped'), 20);
  timer = setTimeout(hideToast, UNDO_MS);
}

/* 25.09: UNDO в пустой корзине — вместо CONTINUE SHOPPING сейчас появятся
   товары и CHECKOUT внизу. Раньше плашка перепрыгивала на CHECKOUT и там
   «возвращала» надпись CONTINUE SHOPPING — выглядело сломанным. Теперь она
   сразу плавно гаснет на месте */
function fadeToast() {
  clearTimeout(timer);
  if (!toast) return;
  const t = toast;
  toast = null;
  pending = [];
  if (keeper) { keeper.disconnect(); keeper = null; }
  t.style.setProperty('transition', 'opacity .2s linear', 'important');
  t.style.setProperty('opacity', '0', 'important');
  t.style.setProperty('pointer-events', 'none', 'important');
  setTimeout(() => t.remove(), 220);
}

async function restore(items) {
  const btn = toast && toast.querySelector('.abc-undo__btn');
  if (btn) btn.disabled = true;
  if (toast && toast.dataset.on === 'empty') fadeToast();

  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'update',
      context: 'cart',
      lines: items.map((item) => ({ merchandiseId: String(item.variant_id), quantity: item.quantity })),
      promise: deferred.promise,
    })
  );

  try {
    const body = { items: items.map((item) => {
      const it = { id: item.variant_id, quantity: item.quantity };
      if (item.properties && Object.keys(item.properties).length) it.properties = item.properties;
      if (item.selling_plan_allocation) it.selling_plan = item.selling_plan_allocation.selling_plan.id;
      return it;
    }) };
    const add = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!add.ok) throw new Error('add failed');

    /* свежая корзина вместе с HTML секций — как отвечает сама тема */
    const cart = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: {}, sections: sectionIds().join(','), sections_url: location.pathname }),
    }).then((r) => r.json());

    snapshot = cart.items || snapshot;
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        sections: cart.sections,
        items: cart.items,
        itemCount: cart.item_count,
        source: 'abc-cart-undo',
        didError: false,
      },
    });
  } catch (e) {
    deferred.reject(e);
  }
  hideToast();
}

document.addEventListener('shopify:cart:lines-update', (e) => {
  const lines = e.lines || (e.detail && e.detail.lines) || [];
  const removed = e.action === 'remove' || lines.some((l) => l && l.quantity === 0);
  const before = snapshot.slice();

  const done = e.promise
    ? e.promise.then(
        (res) => {
          refreshSnapshot();
          return res;
        },
        () => refreshSnapshot()
      )
    : refreshSnapshot();

  if (!removed) return;
  /* удаление пачкой: в одном событии может быть несколько строк */
  const keys = lines.filter((l) => l && l.quantity === 0 && l.id).map((l) => l.id);
  const items = keys.map((k) => before.find((i) => i.key === k)).filter(Boolean);
  if (!items.length) return;
  Promise.resolve(done).then((res) => {
    if (res && res.detail && res.detail.didError) return;
    /* ждём, пока корзина РЕАЛЬНО перерисуется (строк больше нет, итог
       пересчитан) — и только тогда плашка с полными 5 секундами */
    const t0 = Date.now();
    (function wait() {
      const still = keys.some((k) => document.querySelector('cart-items-component .cart-items__table-row[data-key="' + CSS.escape(k) + '"]'));
      if (still && Date.now() - t0 < 6000) { setTimeout(wait, 100); return; }
      setTimeout(() => items.forEach((item) => showToast(item)), 150);
    })();
  });
});

/* шторку закрыли — плашка из неё не нужна */
document.addEventListener('click', (e) => {
  if (toast && e.target.closest && e.target.closest('.theme-drawer__close, [ref="closeButton"]')) hideToast();
});

refreshSnapshot();
